import React from 'react';
import styled from 'styled-components';
import { ShieldCheck, Ticket, Zap } from 'lucide-react';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';

/* Medidas tiradas do layout de referência em 1600×865. */

const highlights = [
    { Icon: Zap, title: 'Sem mensalidade', description: 'Você só paga quando vende', filled: true },
    { Icon: Ticket, title: 'Cadastro em 3 passos', description: 'Resposta em até 48h úteis', tilted: true },
    { Icon: ShieldCheck, title: 'Com ou sem CNPJ', description: 'Do seu jeito, sem burocracia' },
];

/**
 * Chamada da esquerda da /quero-ser-parceiro: o que dá para fazer no Whizr e
 * quanto custa começar, para quem quer vender e não comprar.
 */
function PartnerHero() {
    return (
        <Hero>
            <Headline>
                Venda seus ingressos<br />
                <Highlight>sem montar uma operação.</Highlight>
            </Headline>

            <Lead>
                Publique o evento, receba por Pix e cartão e acompanhe cada lote vendido
                em um painel só.
            </Lead>

            <List>
                {highlights.map(({ Icon, title, description, filled, tilted }) => (
                    <Item key={title}>
                        <IconBox $tilted={tilted}>
                            <Icon
                                size={21}
                                strokeWidth={2}
                                fill={filled ? 'currentColor' : 'none'}
                                aria-hidden='true'
                            />
                        </IconBox>
                        <div>
                            <ItemTitle>{title}</ItemTitle>
                            <ItemDescription>{description}</ItemDescription>
                        </div>
                    </Item>
                ))}
            </List>
        </Hero>
    );
}

const Hero = styled.div`
    display: none;

    @media screen and (min-width: ${breakpoints.lg}) {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: calc(max(36.9375%, 500px) + 40px);
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding: 0 0 137px 67px;
        overflow: hidden;
        color: ${colors.neutralLight};
    }
`;

const Headline = styled.h1`
    margin: 0;
    font-size: 41px;
    font-weight: 600;
    line-height: 48px;
    letter-spacing: -.1px;
    color: ${colors.neutralLight};
    white-space: nowrap;
`;

const Highlight = styled.span`
    background: linear-gradient(90deg, #B585EC 0%, #C396F6 50%, #D1A7FF 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
`;

const Lead = styled.p`
    max-width: 680px;
    margin: 17px 0 0;
    font-size: 19px;
    font-weight: 500;
    line-height: 26px;
    color: rgba(255, 255, 255, .94);
`;

const List = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin: 36px 0 0;
    padding: 0;
    list-style: none;
`;

const Item = styled.li`
    display: flex;
    align-items: center;
    gap: 18px;
`;

const IconBox = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 11px;
    background: rgba(20, 17, 64, .78);
    box-shadow: inset 0 0 0 1px rgba(150, 110, 255, .14);
    color: #B171FF;

    & > svg {
        transform: ${({ $tilted }) => ($tilted ? 'rotate(-45deg)' : 'none')};
        filter: drop-shadow(0 0 4px rgba(177, 113, 255, .45));
    }
`;

const ItemTitle = styled.p`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: ${colors.neutralLight};
`;

const ItemDescription = styled.p`
    margin: 0;
    font-size: 13.5px;
    line-height: 19px;
    color: rgba(255, 255, 255, .84);
`;

export default PartnerHero;
